import { render, staticRenderFns } from "./MainStep.vue?vue&type=template&id=077f44bb&scoped=true"
import script from "./MainStep.vue?vue&type=script&lang=js"
export * from "./MainStep.vue?vue&type=script&lang=js"
import style0 from "./MainStep.vue?vue&type=style&index=0&id=077f44bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077f44bb",
  null
  
)

export default component.exports